import { ImisResponseResult, QueryDefinitionItem } from "../models/imis.models";
import { PopupUtility } from "./popup.utility";
import { RestUtility } from "./rest.utility";

export class QueriesUtility {

    public static async getQueryDefinitionByPath(queryPath: string) {
        let queryDefinition: QueryDefinitionItem = null;

        let queryDefinitionResponse = await RestUtility.restApiSendData<ImisResponseResult<QueryDefinitionItem>>("/api/querydefinition/_execute", {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "FindByPath",
            "Parameters": [queryPath]
        });
        if (queryDefinitionResponse?.Result) {
            queryDefinition = queryDefinitionResponse.Result;
        }

        // ensuring query definition is returned if this is indeed a non-cloud instance response
        if (queryDefinition == null && queryDefinitionResponse?.Result === undefined) {
            queryDefinition = <any>queryDefinitionResponse;
        }

        return queryDefinition;
    }

    public static async openQueryEditorByPath(queryPath: string) {
        let queryDefinition = await QueriesUtility.getQueryDefinitionByPath(queryPath);
        if (queryDefinition != null) {
            PopupUtility.createPopup({
                title: queryPath,
                url: `/iMIS/QueryBuilder/Design.aspx?iMode=Edit&TemplateType=E&iUniformKey=${queryDefinition.QueryDefinitionId}&iOperation=Edit`,
                width: "90%",
                height: "90%",
                windowName: `QueryEditor_${queryDefinition.QueryDefinitionId}`,
                callback: (sender, args) => {
                    // fully remove the popup from the DOM
                    sender.dispose();
                }
            });
        } else {
            let errorMessage = "Query not found for path: " + queryPath;

            console.error(errorMessage);
            throw errorMessage;
        }
    }
}
